import request from "@/utils/request"

const loadTeam = () => {
  return request.get("/api/team_members")
}

const create = ({ seats }) => {
  return request.post("/api/teams", {
    body: {
      seats
    },
    token: true
  })
}

export default {
  loadTeam,
  create
}
